export const Statuses = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    ACTIVE: 'active',
    COMPLETED: 'completed',
    CANCELED: 'canceled',
    NOSHOW: 'no-show',
    PAID: 'paid',
    DECLINED: 'declined'
};
